import { chakra, Image as ChakraImage } from '@chakra-ui/react';
import ImageFadeIn from 'react-image-fade-in';

// eslint-disable-next-line import/prefer-default-export
export const Image = ChakraImage;
export const FadeInImage = chakra(ImageFadeIn);
